import React, { useEffect, useMemo, useState } from "react";
import { Row, Col } from "reactstrap";
import CustomForm from "../../../custom/Forms/CustomForm";
import SelectInput from "../../../custom/components/Select-Input/SelectInput";
import MultiSelectInput from "../../../custom/components/MultiSelect-Input/MultiSelectInput";

import TextInput from "../../../custom/components/Text-Input/TextInput";
import PasswordInput from "../../../custom/components/Password-Input/PasswordInput";

import { Link, useNavigate, useParams } from "react-router-dom";
import { createPageData, basicFormData } from "./UserFile";
import CheckboxInput from "../../../custom/components/CheckBox-Input/CheckboxInput";
import { validate } from "../../../custom/validations/Validate";
import { getRecords, saveRecords } from "../../../services/api.service";
import { toast } from "react-toastify";

const UserCreate = () => {
  const { id } = useParams();
  const schema = localStorage.getItem("schema");
  const navigate = useNavigate();

  const {
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
    payload,
  } = createPageData();

  const initialPayload = useMemo(() => payload, []);
  const [loadingData, setLoadingData] = useState(id ? true : false);
  const [formData, setFormData] = useState(basicFormData());
  const [formErrors, setFormErrors] = useState({});
  // role
  const [roleSelectOptions, setRoleSelectOptions] = useState([]);
  const [selectedRole, setSelectedRole] = useState(null);
  const [isPasswordShown, setIsPasswordShown] = useState(false);

  const [branchSelectOptions, setBranchSelectOptions] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState([]);
  const [OEMSelect, setOEMSelect] = useState(null);
  const [OEMSelectOptions, setOEMSelectOptions] = useState([
    { value: "all", label: "Select All" },
  ]);
  const [selectedZone, setSelectedZone] = useState(null);
  const [zoneOptions, setZoneOptions] = useState([]);

  const [groupSelect, setGroupSelect] = useState(null);
  const [groupSelectOptions, setGroupSelectOptions] = useState([
    { value: "all", label: "Select All" },
  ]);

  useEffect(() => {
    if (id) {
      setIsPasswordShown(true);
      getEditData();
    }
  }, [id]);
  useEffect(() => {
    getRoleData();
    getBranchData();
    getGroupData();
    getOEMData();
  }, []);

  // const getEditData = async () => {
  //   try {
  //     const payload = {
  //       modelName: initialPayload?.modelName,
  //       schema: schema,
  //       whereCondition: { id: id, is_active: true },
  //       include: [
  //         {
  //           model: "role_masters",
  //           as: "role",
  //         },
  //         {
  //           model: "branch_masters",
  //           as: "branch",
  //         },
  //         {
  //           model: "oem_master",
  //           as: "oem",
  //         },
  //         {
  //           model: "group_master",
  //           as: "group",
  //         },
  //       ],
  //     };
  //     const responseData = await getRecords(payload, getEndpoint);

  //     if (responseData?.data && responseData.data.length > 0) {
  //       const data = responseData.data[0];
  //       setFormData({ inputData: data });

  //       setSelectedBranch({
  //         value: data.branch?.id,
  //         label: data.branch?.branch_name,
  //       });
  //       setSelectedRole({ value: data.role?.id, label: data.role?.role_name });
  //     }
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   } finally {
  //     setLoadingData(false);
  //   }
  // };

  const getEditData = async () => {
    try {
      const payload = {
        modelName: initialPayload?.modelName,
        schema: schema,
        whereCondition: { id: id },
        include: [
          { model: "role_masters", as: "role" },
          { model: "branch_masters", as: "branch" },
          { model: "zone_masters", as: "zone" },
        ],
      };

      const responseData = await getRecords(payload, getEndpoint);

      if (responseData?.data?.length > 0) {
        const data = responseData.data[0];
        const { role, branch, oems, groups, zone, ...rest } = data;

        const oemOptions =
          oems?.map((item) => ({
            value: item.id,
            label: item.name,
          })) || [];

        const groupOptions =
          groups?.map((item) => ({
            value: item.id,
            label: item.name,
          })) || [];

        setFormData({
          inputData: {
            ...rest,
            oem_ids: oemOptions.map((opt) => opt.value),
            group_ids: groupOptions.map((opt) => opt.value),
          },
        });

        setSelectedBranch({
          value: branch?.id,
          label: branch?.branch_name,
        });
        setSelectedZone({
          value: zone?.id,
          label: zone?.zone_name,
        });
        fetchZonesByBranch(branch?.id);
        setSelectedRole({
          value: role?.id,
          label: role?.role_name,
        });

        setOEMSelect(oemOptions);
        setGroupSelect(groupOptions);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingData(false);
    }
  };

  const getRoleData = async () => {
    try {
      let payload = {
        modelName: "role_masters",
        whereCondition: {
          is_active: true,
        },
        schema: schema,
        orderBy: {
          field: "role_name",
          order: "asc",
        },
      };

      const responseData = await getRecords(payload, "/getRecords");
      const newArray = responseData.data?.map((item) => ({
        value: item.id,
        label: item.role_name,
      }));
      setRoleSelectOptions(newArray);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const getBranchData = async () => {
    try {
      let payload = {
        modelName: "branch_masters",
        schema: schema,
        whereCondition: { is_active: true },
      };

      const responseData = await getRecords(payload, "/getRecords");
      if (responseData.code === 1) {
        const newArray = responseData.data?.map((item) => ({
          value: item.id,
          label: item.branch_name,
        }));
        setBranchSelectOptions(newArray);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const getOEMData = async () => {
    try {
      let payload = {
        modelName: "oem_master",
        schema: schema,
        whereCondition: { is_active: true },
      };

      const response = await getRecords(payload, "/getRecords");

      if (response && response.code === 1 && Array.isArray(response.data)) {
        const itemOptions = response.data.map((item) => ({
          value: item.id,
          label: item.name,
        }));

        setOEMSelectOptions([
          { value: "all", label: "Select All" },
          ...itemOptions,
        ]);
      } else {
        console.error("Unexpected response format:", response);
        setOEMSelectOptions([{ value: "all", label: "Select All" }]);
      }
    } catch (error) {
      console.error("Error fetching items:", error);
      setOEMSelectOptions([{ value: "all", label: "Select All" }]);
    }
  };
  const getGroupData = async () => {
    try {
      let payload = {
        modelName: "group_master",
        schema: schema,
        whereCondition: { is_active: true },
        orderBy: {
          field: "name",
          order: "asc",
        },
      };

      const response = await getRecords(payload, "/getRecords");

      if (response && response.code === 1 && Array.isArray(response.data)) {
        const itemOptions = response.data.map((item) => ({
          value: item.id,
          label: item.name,
        }));

        setGroupSelectOptions([
          { value: "all", label: "Select All" },
          ...itemOptions,
        ]);
      } else {
        console.error("Unexpected response format:", response);
        setGroupSelectOptions([{ value: "all", label: "Select All" }]);
      }
    } catch (error) {
      console.error("Error fetching items:", error);
      setGroupSelectOptions([{ value: "all", label: "Select All" }]);
    }
  };

  const handleRoleSelect = (options) => {
    const selectedValue = options ? options.value : "";
    const fieldError = validate(validationType, {
      role_id: selectedValue,
    });

    setSelectedRole(options);
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      role_id: fieldError?.role_id || "",
    }));

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        role_id: selectedValue,
      },
    }));
  };
  const fetchZonesByBranch = async (branchId) => {
    if (!branchId) {
      setZoneOptions([]);
      return;
    }

    try {
      const res = await getRecords(
        {
          modelName: "zone_masters",
          schema,
          whereCondition: {
            branch_id: branchId,
            is_active: true,
          },
          orderBy: {
            field: "zone_name",
            order: "asc",
          },
        },
        "/getRecords"
      );

      setZoneOptions(
        (res?.data || []).map((z) => ({
          value: z.id,
          label: z.zone_name,
        }))
      );
    } catch (err) {
      console.error("Error fetching zones", err);
      setZoneOptions([]);
    }
  };
  const handleBranchSelect = (options) => {
    const selectedValue = options ? options.value : "";
    const fieldError = validate(validationType, {
      branch_id: selectedValue,
    });
    setSelectedBranch(options);
    setSelectedZone(null);

    setFormErrors((prevErrors) => ({
      ...prevErrors,
      branch_id: fieldError?.branch_id || "",
    }));

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        branch_id: selectedValue,
        zone_id: null,
      },
    }));
    setZoneOptions([]);
    fetchZonesByBranch(selectedValue);
  };
  const handleOEMSelect = (selectedOptions) => {
    let finalOptions = [];

    if (selectedOptions && selectedOptions.length > 0) {
      const allOption = selectedOptions.find((opt) => opt.value === "all");
      finalOptions = allOption
        ? OEMSelectOptions.filter((opt) => opt.value !== "all")
        : selectedOptions;
    }

    const selectedIds = finalOptions.map((opt) => opt.value);

    // 🔹 validate like single select
    const fieldError = validate(validationType, {
      oem_ids: selectedIds,
    });

    setOEMSelect(finalOptions);

    setFormErrors((prev) => ({
      ...prev,
      oem_ids: fieldError?.oem_ids || "",
    }));

    setFormData((prev) => ({
      ...prev,
      inputData: {
        ...prev.inputData,
        oem_ids: selectedIds,
      },
    }));
  };

  const handleGroupSelect = (selectedOptions) => {
    let finalOptions = [];

    if (selectedOptions && selectedOptions.length > 0) {
      const allOption = selectedOptions.find((opt) => opt.value === "all");
      finalOptions = allOption
        ? groupSelectOptions.filter((opt) => opt.value !== "all")
        : selectedOptions;
    }

    const selectedIds = finalOptions.map((opt) => opt.value);

    // 🔹 validate like single select
    const fieldError = validate(validationType, {
      group_ids: selectedIds,
    });

    setGroupSelect(finalOptions);

    setFormErrors((prev) => ({
      ...prev,
      group_ids: fieldError?.group_ids || "",
    }));

    setFormData((prev) => ({
      ...prev,
      inputData: {
        ...prev.inputData,
        group_ids: selectedIds,
      },
    }));
  };

  const onInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    let updatedValue = value;

    // 🔥 Allow alphabets only + capitalize first letter
    if (name === "first_name" || name === "last_name") {
      updatedValue = value
        .replace(/[^A-Za-z ]+/g, "") // allow alphabets & space only
        .replace(/^\w/, (c) => c.toUpperCase()); // capitalize first letter
    }

    // 🔥 Numbers only for mobile number
    if (name === "mobile_number") {
      updatedValue = value.replace(/[^0-9]/g, "");
    }

    setFormErrors((prevErrors) => {
      const fieldError = validate(validationType, { [name]: updatedValue });
      return {
        ...prevErrors,
        [name]: fieldError[name] || null,
      };
    });

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        [name]:
          type === "checkbox"
            ? checked
              ? 1
              : 0
            : name === "alt_mobile_number" && updatedValue === ""
            ? null
            : updatedValue,
      },
    }));
  };

  const handleSubmit = async (e) => {
    let payload = {
      modelName: initialPayload?.modelName,
      schema: schema,
    };

    try {
      e.preventDefault();
      setLoadingData(true);

      const userDetails = JSON.parse(localStorage.getItem("authUser"));

      const validationErrors = validate(validationType, formData.inputData);
      setFormErrors(validationErrors);
      if (JSON.stringify(validationErrors) !== "{}") return;

      if (id) {
        //update
        formData.inputData.updated_by = id ? userDetails?.id || "" : "";
        payload = {
          ...payload,
          id: id,
          inputData: formData?.inputData,
          relation: [],
        };
        delete payload?.inputData["password"];
      } else {
        // create
        formData.inputData.created_by = userDetails?.id || "";
        formData.inputData.updated_by = userDetails?.id || "";
        payload = { ...payload, inputData: formData?.inputData, relation: [] };
      }

      // console.log(payload);
      // return;
      const responseData = id
        ? await saveRecords(payload, updateEndpoint)
        : await saveRecords(payload, createEndpoint);

      // Handle response and update on localStorage

      if (responseData && responseData.code === 1) {
        if (id && userDetails && userDetails.id === parseInt(id)) {
          const updatedUserDetails = {
            ...userDetails,
            first_name: formData.inputData.first_name,
            last_name: formData.inputData.last_name,
            email_id: formData.inputData.email_id,
            mobile_number: formData.inputData.mobile_number,
            role_id: formData.inputData.role_id,
            branch_id: formData.inputData.branch_id,
            zone_id: formData.inputData.zone_id,
            role_name: selectedRole?.label || userDetails.role_name,
            role_masters: {
              ...(userDetails.role_masters || {}),
              id: formData.inputData.role_id,
              role_name: selectedRole?.label || userDetails.role_masters || {},
            },
          };
          localStorage.setItem("authUser", JSON.stringify(updatedUserDetails));

          // Dispatch events to notify other components
          const event = new Event("userDetailsUpdated");
          window.dispatchEvent(event);
        }
        toast.success(
          `${headerName} ${id ? "updated" : "saved"} successfully!`
        );
        navigate(navigatePage?.back);
      } else {
        toast.error(
          responseData.message || `Error while saving ${headerName}!`
        );
      }
    } catch (error) {
      console.error("Error during submission:", error);
      toast.error("An unexpected error occurred. Please try again.");
    } finally {
      setLoadingData(false);
    }
  };

  return (
    <CustomForm
      title={id ? "UPDATE " + headerName : "CREATE " + headerName}
      loadingData={loadingData}
      onFormSubmit={handleSubmit}
      handleBackClick={() => navigate(navigatePage?.back)}
      id={id}
    >
      <Row className="mt-2">
        <Col md="6" className="mt-3">
          <TextInput
            label="First Name"
            name="first_name"
            value={formData?.inputData?.first_name}
            onChange={onInputChange}
            placeholder="Enter First Name"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.first_name}
          />
        </Col>
        <Col md="6" className="mt-3">
          <TextInput
            label="Last Name"
            name="last_name"
            value={formData?.inputData?.last_name}
            onChange={onInputChange}
            placeholder="Enter Last Name"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.last_name}
          />
        </Col>
        <Col md="6" className="mt-3">
          <SelectInput
            label="role"
            options={roleSelectOptions}
            value={selectedRole}
            onSelect={handleRoleSelect}
            placeholder="Select Role"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.role_id}
          />
        </Col>
        <Col md="6" className="mt-3">
          <SelectInput
            label="branch"
            options={branchSelectOptions}
            value={selectedBranch}
            onSelect={handleBranchSelect}
            placeholder="Select Branch"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.branch_id}
          />
        </Col>
        <Col md="6" className="mt-3">
          <SelectInput
            label="Zone"
            options={zoneOptions}
            value={selectedZone}
            onSelect={(opt) => {
              setSelectedZone(opt);

              setFormData((p) => ({
                ...p,
                inputData: {
                  ...p.inputData,
                  zone_id: opt?.value,
                },
              }));

              setFormErrors((prev) => ({
                ...prev,
                zone_id: null,
              }));
            }}
            placeholder="Select Zone"
            asterisk={true}
            customError={formErrors?.zone_id}
          />
        </Col>
        <Col md="6" className="mt-3">
          <MultiSelectInput
            label="OEM"
            value={OEMSelect}
            options={OEMSelectOptions}
            onMultiSelect={(selected) => handleOEMSelect(selected)}
            placeholder="Select OEM"
            labelClassName="form-label"
            isClearable={true}
            asterisk={true}
            customError={formErrors.oem_ids}
          />
        </Col>
        <Col md="6" className="mt-3">
          <MultiSelectInput
            label="Group"
            value={groupSelect}
            options={groupSelectOptions}
            onMultiSelect={(selected) => handleGroupSelect(selected)}
            placeholder="Select Group"
            labelClassName="form-label"
            isClearable={true}
            asterisk={true}
            customError={formErrors.group_ids}
          />
        </Col>
        <Col md="6" className="mt-3">
          <TextInput
            label="Username"
            name="username"
            value={formData?.inputData?.username}
            onChange={onInputChange}
            placeholder="Enter Username"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.username}
          />
        </Col>
        {selectedRole?.label === "Technician" && (
          <Col md="6" className="mt-3">
            <TextInput
              label="Skill"
              name="skill"
              value={formData?.inputData?.skill}
              onChange={onInputChange}
              placeholder="Enter Skills"
              inputClassName="form-control"
              labelClassName="form-label"
              customError={formErrors?.skill}
            />
          </Col>
        )}

        <Col md="6" className="mt-3">
          <TextInput
            label="Email"
            name="email_id"
            value={formData?.inputData?.email_id}
            onChange={onInputChange}
            placeholder="Enter Email"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.email_id}
          />
        </Col>
        <Col md="6" className="mt-3">
          <PasswordInput
            label="Password"
            name="password"
            value={formData?.inputData?.password}
            onChange={onInputChange}
            placeholder="Enter Password"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.password}
            type={isPasswordShown ? "password" : "text"}
            disabled={id ? true : false}
          />
        </Col>
        <Col md="6" className="mt-3">
          <TextInput
            label="Mobile Number"
            name="mobile_number"
            value={formData?.inputData?.mobile_number}
            onChange={onInputChange}
            placeholder="Enter Mobile Number"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.mobile_number}
          />
        </Col>
      </Row>

      {/* Add documents */}

      <Row className="mt-4">
        <Col lg="12">
          <CheckboxInput
            name="is_active"
            label="Is Active"
            value={formData?.inputData?.is_active}
            checked={formData?.inputData?.is_active}
            handleTextChange={onInputChange}
            parentClassName="form-check"
            checkBoxClassName="form-check-input"
            labelClassName="form-check-label"
          />
        </Col>
      </Row>
    </CustomForm>
  );
};

export default UserCreate;
